import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { store } from "../../Store";
import { useTranslationsById } from "../../../hooks/use-translations-by-id";

export const LinksSection = ({ title, linksData }) => {
	const footerTexts = useTranslationsById({ mainSectionName: "footer" });
	const globalStateContext = useContext(store);
	const state = globalStateContext?.state;
	const isAuth = state?.sesionActiva === "SI";
	const links = Array.isArray(linksData) ? linksData : [];

	return (
		<div className="footer-links-section">
			<h3 className="footer-column-title subheading-2">{title}</h3>
			<ul className="footer-links">
				{links?.map((link, i) => (
					<li key={i}>
						{link.external ? (
							<a
								className="link focusable-primary"
								href={link?.link || ""}
								target={`${link.target ? link.target : "_self"}`}
								rel={`${link.rel ? link.rel : null}`}
							>
								{footerTexts.getText({
									id: link?.text?.translationId,
									defaultText: link?.text?.default,
								})}
							</a>
						) : (
							<Link
								className="link focusable-primary"
								to={link?.byAuth === true ? link.link(isAuth) : link.link}
							>
								{footerTexts.getText({
									id: link?.text?.translationId,
									defaultText: link?.text?.default,
								})}
							</Link>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
